import { render, staticRenderFns } from "./RejectForm.modal.vue?vue&type=template&id=4b08bd6a&scoped=true&"
import script from "./RejectForm.modal.vue?vue&type=script&lang=ts&"
export * from "./RejectForm.modal.vue?vue&type=script&lang=ts&"
import style0 from "./RejectForm.modal.vue?vue&type=style&index=0&id=4b08bd6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b08bd6a",
  null
  
)

export default component.exports